import React, {memo} from 'react';

import Sizes from './sizes/';
import Options from './options/';
import Sales from './sales/';


const Complex = memo((props) => {
	const idx = props.typewindowdata.findIndex((el) => el.id === props.mainstate.currentTypeWindowId);
	return (
		<div className="wincalc-complex">
			<Sizes
				typewindowdata={props.typewindowdata[idx]}
				window_width = {props.mainstate.window_width}
				window_height = {props.mainstate.window_height}
				onUpdateWidth = {props.onUpdateWidth}
				onUpdateHeight = {props.onUpdateHeight}
			/>
			<Options
				mainstate={props.mainstate}
				typewindowdata={props.typewindowdata[idx]}
				onChangeOptionCheckbox = {props.onChangeOptionCheckbox}
			/>
			<Sales
				salesdata={props.salesdata}
				onChangeSale = {props.onChangeSale}
			/>
		</div>
	)
})


export default Complex;

